var _rect, _rect2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGridList = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 36,
  viewBox: "0 0 70 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 69,
  height: 34.6897,
  rx: 4.5,
  stroke: "#4F31FF"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  className: "background",
  width: 35,
  height: 35,
  rx: 5,
  fill: "#4F31FF"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "tiles",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 9,
  width: 8,
  height: 8,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 9,
  width: 8,
  height: 8,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 18,
  width: 8,
  height: 8,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 18,
  width: 8,
  height: 8,
  rx: 1
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  className: "bars",
  fill: "#4F31FF",
  stroke: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 45.5,
  y: 19.0217,
  width: 17,
  height: 2.26087,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 45.5,
  y: 10.5,
  width: 17,
  height: 2.26087,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 45.5,
  y: 14.7609,
  width: 17,
  height: 2.26087,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 45.5,
  y: 23.2826,
  width: 17,
  height: 2.26087,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 19.0217,
  width: 2,
  height: 2.26087,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 10.5,
  width: 2,
  height: 2.26087,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 14.7609,
  width: 2,
  height: 2.26087,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 23.2826,
  width: 2,
  height: 2.26087,
  rx: 0.5
}))));
export default SvgGridList;